<link defer href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css" rel="stylesheet"
    crossorigin="anonymous" integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2">
<!-- <ng-defer [trigger$]="trigger$">
</ng-defer> -->
    <div class="home-body" >
        <div class="ab-container" >
            <div   *ngIf="_as.isOnMobilePlatform">
             <div class="row-new-launche-btn hght">
                <!-- (click)="onNewLaunchesClick()" -->
                <div class="new-launche-btn" (click)="_homeservice.isdisplybrandpopup = true;">
                    <button>
                        <img ngOptimizedImage width="18" height="18" ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/shuttle_rgc5h6.png" alt="new-launches" loading="lazy">
                        Brand
                    </button>
                </div>
                <div class="find-by-budget-btn" (click)="onFindByBudgetClick()">
                       <button>
                        <img ngOptimizedImage width="18" height="18" ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/budget_xvqv0c.png" alt="find by budget" loading="lazy">
                        By budget
                    </button>
                </div>
                <!-- (click)="_homeservice.isdisplybrandpopup = true;" -->
                <!-- <div class="more-btn"  *ngIf="brand_list?.length" routerLink="./brand">
                    <button>Brand</button>
                </div> -->
                <div class="more-btn"  >
                    <!-- [routerLink]="productSampUrl" [queryParams]="productSampQueryParm" -->
                  <button (click)="_ds.samplesVisible = true">
                    <img ngOptimizedImage 
                    ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/sample-colot-icon_ss5obr.png"
                    alt="Professionals" width="18" height="18" loading="lazy">
                    Sample
                  </button>  
                 
                </div>
             </div>
            </div>
         <div class="wt-block">  
            <div class="core-option-sec sec-gap-py" *ngIf="isBrowser">
                <div >
                
                    <!-- <div class="heading-block ">
                        <h2>
                         Interior ecosystem all in one place.
                        </h2>
                        <p class="w-block wt-block">
                            Explore every category, trusted Sellers, interior Experts & compare the best deals before making
                            your Purchase
                        </p>
                    </div> -->
                    <!-- (mouseleave)="closecorepopup()" -->
                    <div class="core-menu-sec" id="main-options-container">
                        <div class="core-menu-list d-flex justify-content-around">
                            <button class="cm-btn" (click)="onCoreOptions('product')"
                                [ngClass]="{'active-cm-btn':active_option==='product'}">
                                <div class="et-card">
                                    <img ngOptimizedImage class="et-img"
                                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/1_ury3xx.png"
                                        alt="Interior products" width="64" height="64" loading="lazy">
                                    <div class="et-text">
                                        <span>Products</span>
                                        <!-- <span>Latest & Trending</span> -->
                                    </div>
                                </div>
                            </button>
                            <button class="cm-btn" (click)="onCoreOptions('manufacturer')"
                                [ngClass]="{'active-cm-btn':active_option==='manufacturer'}">
                                <div class="et-card">
                                    <img class="et-img" ngOptimizedImage
                                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/2_zackxv.png"
                                        alt="Interior brands" width="64" height="64" loading="lazy">
                                    <div class="et-text">
                                        <span>Brands</span>
                                        <!-- <span>Top & Credible</span> -->
                                    </div>
                                </div>
                            </button>
                            <!-- <button class="cm-btn" (click)="onCoreOptions('dealer')"
                                [ngClass]="{'active-cm-btn':active_option==='dealer'}">
                                <div class="et-card">
                                    <img class="et-img" ngOptimizedImage
                                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Seller_mv6lpj.png"
                                        alt="Showrooms" width="64" height="64" loading="lazy">
    
                                    <div class="et-text">
                                        <span>Showrooms</span>
                                    </div>
                                </div>
                            </button> -->
                            <button class="cm-btn" (click)="onProfessionalOptions()"
                                [ngClass]="{'active-cm-btn':active_option==='professional'}">
                                <div class="et-card">
    
                                    <img class="et-img" ngOptimizedImage
                                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/4_urlkxo.png"
                                        alt="Professionals" width="64" height="64" loading="lazy">
                                    <div class="et-text">
                                        <span>Professionals</span>
                                        <!-- <span>Verified & trusted</span> -->
                                    </div>
                                </div>
                            </button>
                            <!-- [routerLink]="productSampUrl" [queryParams]="productSampQueryParm" -->
                        <button class="cm-btn"  (click)="_ds.samplesVisible = true">
                            <div class="et-card">
                                <img class="et-img smple-img" ngOptimizedImage style="width: 40px;"
                                    ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/5_jgou46.png"
                                    alt="Professionals" width="64" height="64" loading="lazy">
                                <div class="et-text">
                                    <span>Sample</span>
                                </div>
                            </div>
                         </button>
                        <button class="cm-btn ab-btn-sec-nav-a" routerLink="./smart-search" [queryParams]="{q:''}" *ngIf="!onSmartView()">
                        <div class="et-card">
                            <img class="et-img" ngOptimizedImage style="width: 31px;"
                                 ngSrc="assets/images/icons/smart-search.png"
                                 alt="Professionals" width="64" height="64" loading="lazy">
                            <div class="et-text">
                                <span>Smart Search</span>
                            </div>
                        </div>
                    </button>
                        </div>
                        <div class="core-pop-container">
                            <div class="left-side-box" *ngIf="isCoreOption">
                                <p class="option-heading">{{getOptionHeading()}}</p>
                                <div class="pros-popover-close" (click)="closecorepopup()">
                                    <i class="fa-solid fa-xmark"></i>
                                </div>
                                <div class="departments-popover"
                                    *ngIf="(active_option==='product' || active_option==='manufacturer' || active_option==='dealer' || active_option==='articl') && active_pros_option!=='professional'">
                                    <div class="d-item" [ngClass]="{'active-item':activermainoptionsindex===mci}"
                                        (click)="mainCategoryoption(mci)"
                                        *ngFor="let main of active_categorys;let mci=index">
                                        <img ngOptimizedImage [src]="main?.icon" [alt]="main.name" width="40" height="40"
                                            loading="lazy">
                                        <span>{{main?.name}}</span>
                                    </div>
                                </div>
                                <div class="departments-popover" *ngIf="active_option==='professional'">
                                    <a class="professional-works" (click)="onProfessional(prof, pi)" [title]="prof?.name"
                                        [ngClass]="{'active-professional-work':pi===activeprofTypeindex}"
                                        *ngFor="let prof of pro_types;let pi=index">
                                        <div class="blank-circle" [ngClass]="{'active-circle':pi===activeprofTypeindex}">
                                        </div>
                                        <div class="pro-type">{{prof?.name}}</div>
                                    </a>
                                </div>
                            </div>
                            <div class="right-side-box" *ngIf="activeCoreSubCategory">
                                <div class="sub-categorys" *ngIf="active_option==='product' && activeCoreSubCategory">
                                    <a class="sub-cat-link"
                                        routerLink="./d/{{_ds.departments_list[activermainoptionsindex]?.slug_name}}/{{sub.slug_name}}"
                                        [ngClass]="{'ab-pointer-events': sub?.is_coming_soon}" [title]="sub.name"
                                        *ngFor="let sub of _ds.departments_list[activermainoptionsindex]?.sub_category_list;let mci=index;let last=last">
                                        <img ngOptimizedImage *ngIf="sub.icon" [src]="sub?.icon" width="60" height="60"
                                            [alt]="sub?.name" loading="lazy">
                                        <p> {{sub.name}}</p>
                                    </a>
                                </div>
                                <!-- style="grid-template-columns: repeat(3, 1fr);" -->
                                <div class="sub-categorys" *ngIf="active_option==='manufacturer' && category_brand_load">
                                    <a class="sub-cat-link" routerLink="./brand/{{brand?.slug_name}}"
                                        [title]="brand?.brand_name"
                                        style="height: 95px; display: flex ; justify-content: center;"
                                        *ngFor="let brand of category_brand_list;let mci=index;let last=last">
                                        <img ngOptimizedImage [src]="brand?.logo" [alt]="brand?.brand_name" loading="lazy"
                                            style="height:41px;margin: auto;" width="96" height="41">
                                    </a>
                                </div>
                                <div class="sub-categorys" *ngIf="active_option==='dealer'">
                                    <a class="sub-cat-link" routerLink="/dealer"
                                        [queryParams]="{ mcId:_ds.departments_list[activermainoptionsindex].id,cityId :city.id}"
                                        [title]="city?.name" *ngFor="let city of dealer_citys;let mci=index;let last=last">
                                        <img ngOptimizedImage [src]="city?.icon_url" [alt]="city?.name" class="ct-icon-h40"
                                            width="40" height="40" loading="lazy">
                                        <p class="mt-8px"> {{city.name}}</p>
                                    </a>
                                </div>
                                <div class="sub-categorys" *ngIf="active_option==='professional'">
                                    <a class="sub-cat-link" (click)="onSelectCity(city)"
                                        *ngFor="let city of prof_locations;let pli=index;let last=last">
                                        <img ngOptimizedImage [src]="city?.icon_url" [alt]="city?.name" class="ct-icon-h40"
                                            width="40" height="40" loading="lazy">
                                        <p class="mt-8px"> {{city.name}}</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="hero-carousel-sec" *ngIf="_is_hero_list" [@fadeimagesInOut]>
                <div *ngFor="let hero of hero_banner_list; let i = index">
                  <a class="d-block" [routerLink]="hero?.link" *ngIf="!hero?._homeservice">
                    <div class="slider-wrapper-text" *ngIf="hero?.title">
                      <h2 class="text-shodow-2 text-white">{{hero?.title}}</h2>
                      <span class="text-shodow-2 text-white">{{hero?.sub_title}}</span>
                    </div>
                    <img ngOptimizedImage
                      fetchpriority="high"
                      [ngSrc]="hero?.imgUrl"
                      [srcset]="hero?.srcset"
                      sizes="100vw"
                      [alt]="hero?.altText"
                      class="hero-banner"
                      width="1600" height="500"
                      [loading]="i === 0 ? 'eager' : 'lazy'"
                      [style.background]="hero?.lqipUrl ? 'url(' + hero?.lqipUrl + ')' : 'none'"
                      style="background-size: cover; background-position: center;">
                  </a>
                  <a class="d-block" (click)="_homeservice.isdisplybrandpopup = true;" *ngIf="hero?._homeservice">
                    <div class="slider-wrapper-text" *ngIf="hero?.title">
                      <h2 class="text-shodow-2 text-white">{{hero?.title}}</h2>
                      <span class="text-shodow-2 text-white">{{hero?.sub_title}}</span>
                      <div class="j-for-f-btn">
                        <button (click)="_homeservice.isdisplybrandpopup = true;">Explore</button>
                      </div>
                    </div>
                    <img ngOptimizedImage
                      fetchpriority="high"
                      [ngSrc]="hero?.imgUrl"
                      [srcset]="hero?.srcset"
                      sizes="100vw"
                      [alt]="hero?.altText"
                      class="hero-banner"
                      width="1600" height="500"
                      [loading]="i === 0 ? 'eager' : 'lazy'"
                      [style.background]="hero?.lqipUrl ? 'url(' + hero?.lqipUrl + ')' : 'none'"
                      style="background-size: cover; background-position: center;">
                  </a>
                </div>
              </div>
              <div class="m-block">
                <div class="core-option-sec sec-gap-py" *ngIf="isBrowser">
                    <!-- Removed 1 -->
                    <div >
                        <div class="heading-block ">
                            <h2 >
                                Interior ecosystem <br> in one place.
                            </h2>
                             <p>
                            Explore brands, products & materials. Meet designers and contractors.
                             </p>
                        </div>
                        <!-- (mouseleave)="closecorepopup()" -->
                        <div class="core-menu-sec" id="main-options-container">
                            <div class="core-menu-list d-flex justify-content-around">
                                <button class="cm-btn" (click)="onCoreOptions('product')"
                                    [ngClass]="{'active-cm-btn':active_option==='product'}">
                                    <div class="et-card">
                                        <img ngOptimizedImage class="et-img"
                                            ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/1_ury3xx.png"
                                            alt="Interior products" width="64" height="64" loading="lazy">
                                        <div class="et-text">
                                            <span>Products</span>
                                            <span>Latest & Trending</span>
                                        </div>
                                    </div>
                                </button>
                                <button class="cm-btn" (click)="onCoreOptions('manufacturer')"
                                    [ngClass]="{'active-cm-btn':active_option==='manufacturer'}">
                                    <div class="et-card">
                                        <img class="et-img" ngOptimizedImage
                                            ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/2_zackxv.png"
                                            alt="Interior brands" width="64" height="64" loading="lazy">
                                        <div class="et-text">
                                            <span>Brands</span>
                                            <span>Top & Credible</span>
                                        </div>
                                    </div>
                                </button>
                                <!-- <button class="cm-btn" (click)="onCoreOptions('dealer')"
                                    [ngClass]="{'active-cm-btn':active_option==='dealer'}">
                                    <div class="et-card">
                                        <img class="et-img" ngOptimizedImage
                                            ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Seller_mv6lpj.png"
                                            alt="Showrooms" width="64" height="64" loading="lazy">
        
                                        <div class="et-text">
                                            <span>Showrooms</span>
                                            <span>Auth & Franchise</span>
                                        </div>
                                    </div>
                                </button> -->
                                <button class="cm-btn"  (click)="_ds.samplesVisible = true">
                                    <div class="et-card">
                                        <img class="et-img smple-img" ngOptimizedImage 
                                            ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/5_jgou46.png"
                                            alt="Professionals" width="64" height="64" loading="lazy">
                                        <div class="et-text">
                                            <span>Sample</span>
                                            <span>Absolutely free </span>
                                        </div>
                                    </div>
                                 </button>
                                <button class="cm-btn" (click)="onProfessionalOptions()"
                                    [ngClass]="{'active-cm-btn':active_option==='professional'}">
                                    <div class="et-card">
        
                                        <img class="et-img" ngOptimizedImage
                                            ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/4_urlkxo.png"
                                            alt="Professionals" width="64" height="64" loading="lazy">
                                        <div class="et-text">
                                            <span>Professionals</span>
                                            <span>Verified & trusted</span>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div class="core-pop-container">
                                <div class="left-side-box" *ngIf="isCoreOption">
                                    <p class="option-heading">{{getOptionHeading()}}</p>
                                    <div class="pros-popover-close" (click)="closecorepopup()">
                                        <i class="fa-solid fa-xmark"></i>
                                    </div>
                                    <div class="departments-popover"
                                        *ngIf="(active_option==='product' || active_option==='manufacturer' || active_option==='dealer' || active_option==='articl') && active_pros_option!=='professional'">
                                        <div class="d-item" [ngClass]="{'active-item':activermainoptionsindex===mci}"
                                            (click)="mainCategoryoption(mci)"
                                            *ngFor="let main of active_categorys;let mci=index">
                                            <img ngOptimizedImage [src]="main?.icon" [alt]="main.name" width="40" height="40"
                                                loading="lazy">
                                            <span>{{main?.name}}</span>
                                        </div>
                                    </div>
                                    <div class="departments-popover" *ngIf="active_option==='professional'">
                                        <a class="professional-works" (click)="onProfessional(prof, pi)" [title]="prof?.name"
                                            [ngClass]="{'active-professional-work':pi===activeprofTypeindex}"
                                            *ngFor="let prof of pro_types;let pi=index">
                                            <div class="blank-circle" [ngClass]="{'active-circle':pi===activeprofTypeindex}">
                                            </div>
                                            <div class="pro-type">{{prof?.name}}</div>
                                        </a>
                                    </div>
                                </div>
                                <div class="right-side-box" *ngIf="activeCoreSubCategory">
                                    <div class="sub-categorys" *ngIf="active_option==='product' && activeCoreSubCategory">
                                        <a class="sub-cat-link"
                                            routerLink="./d/{{_ds.departments_list[activermainoptionsindex]?.slug_name}}/{{sub.slug_name}}"
                                            [ngClass]="{'ab-pointer-events': sub?.is_coming_soon}" [title]="sub.name"
                                            *ngFor="let sub of _ds.departments_list[activermainoptionsindex]?.sub_category_list;let mci=index;let last=last">
                                            <img ngOptimizedImage *ngIf="sub.icon" [src]="sub?.icon" width="60" height="60"
                                                [alt]="sub?.name" loading="lazy">
                                            <p> {{sub.name}}</p>
                                        </a>
                                    </div>
                                    <!-- style="grid-template-columns: repeat(3, 1fr);" -->
                                    <div class="sub-categorys" *ngIf="active_option==='manufacturer' && category_brand_load">
                                        <a class="sub-cat-link" routerLink="./brand/{{brand?.slug_name}}"
                                            [title]="brand?.brand_name"
                                            style="height: 95px; display: flex ; justify-content: center;"
                                            *ngFor="let brand of category_brand_list;let mci=index;let last=last">
                                            <img ngOptimizedImage [src]="brand?.logo" [alt]="brand?.brand_name" loading="lazy"
                                                style="height:41px;margin: auto;" width="96" height="41">
                                        </a>
                                    </div>
                                    <div class="sub-categorys" *ngIf="active_option==='dealer'">
                                        <a class="sub-cat-link" routerLink="/dealer"
                                            [queryParams]="{ mcId:_ds.departments_list[activermainoptionsindex].id,cityId :city.id}"
                                            [title]="city?.name" *ngFor="let city of dealer_citys;let mci=index;let last=last">
                                            <img ngOptimizedImage [src]="city?.icon_url" [alt]="city?.name" class="ct-icon-h40"
                                                width="40" height="40" loading="lazy">
                                            <p class="mt-8px"> {{city.name}}</p>
                                        </a>
                                    </div>
                                    <div class="sub-categorys" *ngIf="active_option==='professional'">
                                        <a class="sub-cat-link" (click)="onSelectCity(city)"
                                            *ngFor="let city of prof_locations;let pli=index;let last=last">
                                            <img ngOptimizedImage [src]="city?.icon_url" [alt]="city?.name" class="ct-icon-h40"
                                                width="40" height="40" loading="lazy">
                                            <p class="mt-8px"> {{city.name}}</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            <!-- *ngIf="!_is_hero_list && !isBrowser" -->
            <div class="hero-carousel-sec-loader" *ngIf="!isBrowser">
                <div class="hero-img-loader skeleton-box w-100"></div>
            </div>
            <div class=" wt-block">
                <app-testimonials></app-testimonials>
            </div>
        </div>
        <div class="product-gallery-sec" *ngIf="isBrowser">
            <div class="ab-container">
                <div class="row pgs-b" data-id="ab7-5">
                    <div class="col-sm-12 col-md-7">
                        <a class="p-card-i" title="Get best discounts on Interior materials and Products"(click)="_homeservice.isdisplybrandpopup = true;">
                            <!-- <div class="fig-caption">
                                <h2 class="text-shodow-2 text-white">Elevate Daily Self-Care</h2>
                                <p class="text-shodow-2 text-white">Upgrade your routine with premium bathroom fittings
                                </p>
                            </div> -->
                            <img ngOptimizedImage width="727" height="435" loading="lazy" 
                            ngSrc="assets/images/home/1st image.webp"
                                alt="Modern bathroom fittings in a sleek design" >

                                <!-- <img ngOptimizedImage width="727" height="435" loading="lazy"
                                ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Final_nfwdam.webp"
                                    ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Final_nfwdam.webp"
                                    alt="Modern bathroom fittings in a sleek design" > -->
                        </a>
                    </div>
                    <div class="col-sm-12 col-md-5 ">
                        <!-- routerLink="./brand/haier"[queryParams]="{ subCat:128,page :1}" -->
                        <a class="p-card-i" title="Free material samples" (click)="_ds.samplesVisible = true">
                            <div class="fig-caption ">
            
                                 <!-- <h2 class="text-shodow-2 text-900">Try Before You Buy</h2>
                                <p class="text-shodow-2 text-900">Get free material samples within 24 hours</p> -->
                            </div>
                             <img ngOptimizedImage width="513" height="434" loading="lazy"
                                ngSrc="assets/images/home/2nd Image.webp"alt="Try Before You Buy Sample">
                        </a>
                    </div>
                </div>
                <div class="row pgs-b" data-id="ab6-3-3">
                    <div class="col-sm-6 col-md-3 small-left">
                        <!-- <a class="p-card-i" title="Curated Sellers near You" routerLink="./department/woodwork"> -->
                            <a class="p-card-i" title="Curated Sellers near You" style="pointer-events: none;">
                            <!-- <div class="fig-caption ">
                                <h2 class="text-shodow-2 text-white">Perfect Interior<br> Materials</h2>
                            </div> -->
                            <img ngOptimizedImage width="388" height="563" loading="lazy"
                                ngSrc="assets/images/home/3rd image (11).webp"
                                alt="Interior woodwork materials display">
                        </a>
                    </div>
                    <div class="col-sm-6 col-md-3 small-right">
                        <!-- <a class="p-card-i" title="Find Best Professionals" routerLink="./service-provider"> -->
                             <a class="p-card-i" title="Find Best Professionals" style="pointer-events: none;">
                            <!-- <div class="fig-caption ">
                                <h2 class="text-shodow-2  text-900">Request a Quote</h2>
                                <p class="text-shodow-2 text-900">Upload your Bill of Material</p>
                            </div> -->
                            <img ngOptimizedImage width="388" height="563" loading="lazy"
                                ngSrc="assets/images/home/4rth image (10).webp"
                                alt="Professional interior designer working on a project">
                        </a>
                        <!-- <a class="p-card-i" title="Find Best Professionals" routerLink="./service-provider">
                            <div class="fig-caption ">
                                <h2 class="text-shodow-2 text-white">Find Best <br> Professionals</h2>
                            </div>
                            <img ngOptimizedImage width="388" height="563" loading="lazy"
                                ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Final_4_lwuvxm.webp"
                                alt="Professional interior designer working on a project">
                        </a> -->
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <a class="p-card-i" title="No budget is too small" (click)="onBudget()">
                            <!-- <div class="fig-caption ">
                                <h2 class="text-900">No budget is too small</h2>
                                <p class="text-900">Afterbricks finds products for every budget and home. Just click and try
                                </p>
                            </div> -->
                            <img ngOptimizedImage width="727" height="435" loading="lazy"
                                ngSrc="assets/images/home/5th Image.webp" alt="Budget-friendly home decor products">
                        </a>
                        <!-- <a class="p-card-i" title="cashback" routerLink="cashback">
                            <div class="w-block">
                                <div class="fig-caption " style="right:0px">
                                    <h2 class="text-900" style="border: 1px solid #cdb6ff;font-size: 20px; border-radius:6px;background-color: rgba(209, 171, 255, 0.8705882353);
                                     box-shadow: 0 1px 3px rgba(36, 39, 44, 0.1490196078);padding: 8px 32px;">
                                    Soon</h2>
                                    <p class="text-900">Banner will come here</p>
                                </div> 
                            </div>
                            <div class="m-block">
                                <div class="fig-caption " style="right:0px">
                                    <h2 class="text-900" style="border: 1px solid #cdb6ff;font-size:15px; border-radius:6px;background-color: rgba(209, 171, 255, 0.8705882353);
                                     box-shadow: 0 1px 3px rgba(36, 39, 44, 0.1490196078);padding: 4px 24px;">
                                    Soon</h2>
                                    <p class="text-900">Banner will come here</p>
                                </div> 
                            </div>
                           
                            <img ngOptimizedImage width="727" height="435" loading="lazy"
                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1724318021/Cashback_image_fzwxb3.webp"
                                alt="Cashback">
                        </a> -->
                    </div>
                </div>
           
            </div>
           
        </div>
        <div class="offer-sec sec-gap-py" *ngIf="isBrowser">
            <div class="ab-container" *ngIf="!_as.isOnMobilePlatform">
                <div class="heading-block text-center mb-0">
                    <h2>
                        Material Categories
                    </h2>
                    <p>
                        Stunning range for your dream space
                    </p>
                <ul class="offer-ul">
                    <li *ngFor="let offer of homepage_offercard;let oi=index">
                        <a class="offer-card p-card-i" [routerLink]="offer.link" [queryParams]="offer.queryparams">
                            <img ngOptimizedImage [ngSrc]="offer.imgurl" alt="Interior & Architectural Products"
                                class="offer-card-img" style="width: 100%;" width="150" height="200" loading="lazy">
                        </a>
                        <span>{{offer.title}}</span>
                    </li>
                </ul>
                <!-- <owl-carousel-o [options]="_owlservice.owlHomeoffercard">
                    <ng-container *ngFor="let offer of homepage_offercard;let oi=index">
                        <ng-template carouselSlide [dataMerge]="oi + 1">
                            [queryParams]="offer.queryparams"
                            <a class="offer-card " [routerLink]="offer.link" [queryParams]="offer.queryparams">
                                <img ngOptimizedImage [ngSrc]="offer.imgurl" alt="offer-card" class="offer-card-img"
                                    style="width: 100%;" width="150" height="400" loading="lazy">
                            </a>
                        </ng-template>
                    </ng-container>

                </owl-carousel-o> -->
                </div>
            </div>
            <div class="ab-container" *ngIf="_as.isOnMobilePlatform">
                <div class="heading-block text-center">
                    <h2>
                        Material Categories
                    </h2>
                    <p>
                        Stunning range for your dream space
                    </p>
                <ul class="offer-ul">
                    <li *ngFor="let offer of homepage_offercard;let oi=index">
                        <a class="offer-card " [routerLink]="offer.link" [queryParams]="offer.queryparams">
                            <img ngOptimizedImage [ngSrc]="offer.imgurl" alt="Interior & Architectural Products"
                                class="offer-card-img" style="width: 100%;" width="150" height="200" loading="lazy">
                        </a>
                        <span>{{offer.title}}</span>
                    </li>
                </ul>
            </div>
        </div>
                <div class=" m-block">
            <div class="ab-container" ><app-testimonials></app-testimonials></div>

        </div>
        </div>
        <!-------------------loader-------------------->
        <div class="ab-container is-loading" *ngIf="global_loader || !isBrowser">
            <div class="m-block w-100 " style="margin-bottom: 16px;">
                <div class="youtube-container sec-gap-mb mb-0">
                    <div class="side2 side-bg name mb-0"></div>
                    <div class="side1 side-bg  name mb-0"></div>
                    <a class="side3 side-bg  name mb-0"></a>
                </div>
            </div>
            <div class="wt-block w-100">
                <div class="youtube-container sec-gap-mb mb-0">
                    <div class="side1 side-bg name mb-0"></div>
                    <div class="side2 side-bg name mb-0"></div>
                    <div class="side3 side-bg name mb-0"></div>
                </div>
            </div>

        </div>
        <!----------END loader------------->
       <!-- <div  class="ab-container"> -->
        <div class="brand-sec " *ngIf="isBrowser">
            <div  class="ab-container sec-gap-py">
                <div class="heading-block text-center">
                    <h2>
                        Brands we trust.
                    </h2>
                    <p>
                        Explore {{_ds.product_count | thousandSuff : 2}} SKU’s from {{total_brand}} credible brands +
                        growing
                    </p>
                </div>
                <div>
                    <div class="marquee">
                        <div class="marquee__content">
                            <ul class="list-inline">
                                <li *ngFor="let brand of brand_list;let i = index">
                                    <div class="brand-logo">
                                        <div class="brand-list p-card-i">
                                            <a class="img-card" routerLink="./brand/{{brand?.slug_name}}"
                                                [title]="brand?.brand_name">
                                                <div class="brand-list-img">
                                                    <img ngOptimizedImage width="124" height="53"
                                                        ngSrc="{{brand?.brand__logo}}" [alt]="brand?.brand_name"
                                                        [@fadeimagesInOut] loading="lazy" />
                                                </div>
                                                <div class="cashback-chip" *ngIf="brand.cashback">
                                                    <p> Cashback {{brand?.cashback?.cashback}}%</p>
                                                </div>
                                            </a>

                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center sec-footer" *ngIf="brand_list?.length">
                    <a title="View All brands" class="hm_btn" routerLink="./brand"> View All</a>
                </div>
            </div>
        </div>
       <!-- </div> -->
       
        <div class="explore-department-sec sec-gap-py"  *ngIf="!global_loader">
            <div class="ab-container">
                <div class="heading-block text-center">
                    <h2>
                        Explore from {{_ds.departments_list?.length}} departments.
                    </h2>
                    <p>
                        {{_ds.product_count | thousandSuff : 2 }} products, {{_ds.categopry_count}} categories,
                        {{_ds.category_type_count}} types + growing
                    </p>
                </div>
                <div class="w-100 ">
                    <app-global-department></app-global-department>
                </div>
                
            </div>
            
        </div>

        <!----New-trand---->

    <div class="new-trends-sec sec-gap-py" *ngIf="isBrowser">
        <div class="ab-container ">
            <div class="heading-block text-center">
                <h2>
                    New trends for the month.
                </h2>
                <p>
                    Carefully Curating Inspiring Products to Spark Your Creativity
                </p>
            </div>
            <div class="tranding-products">
                <div class="card-p" *ngFor="let populerProd of mostsearchproducts;let i=index">
                    <a class="card-p-a" routerLink="./p/{{populerProd.slug_name}}" [title]="populerProd?.name"
                        (click)="ctr('most_search',populerProd.id)">
                        <div class="brand-logo-p">
                            <img ngOptimizedImage width="96" height="41" [ngSrc]="populerProd?.logo"
                                [alt]="populerProd?.brand_name" loading="lazy" />
                        </div>
                        <div class="p-img">
                            <img ngOptimizedImage [ngSrc]="populerProd?.image" [alt]="populerProd?.name" width="300"
                                height="225" loading="lazy" />
                        </div>
                        <div class="p-text mb-2">
                            <span>{{populerProd?.brand_name}}</span>
                            <h2>{{populerProd?.name}}</h2>
                        </div>
                    </a>
                </div>
            </div>
            <div class="d-flex justify-content-center sec-footer">
                <button class="hm_btn" (click)="getmostsearchproducts(false)">View More Products</button>
            </div>
    
        </div>
    </div>
  

<!----End-New-trand-->
        <!-- End-Three-Card-Section -->    

    </div>
   
        <!-- Start-Three-Card-Section -->
        <div class="ab-container" *ngIf=" isBrowser">
        
            <!-- <div class="m-block w-100 " style="margin-bottom: 0px;">
                <div class="youtube-container sec-gap-mb mb-0">
                    <div class="side1 side-bg shadow-5" (click)="_homeservice.isdisplybrandpopup = true;">
                   
                    <img ngOptimizedImage src="https://res.cloudinary.com/afterbricks/image/upload/v1705923651/mobile_banners_2_vtf1se.webp"
                        alt="explore">
                </div>
                    <div class="side2 side-bg">
                        <a class="vd-card" title="afterbricks youtube" href="https://youtu.be/t3hpjFHOgNM"
                            target="_blank">
                            <div class="eve-title">
                                <div class="fs-card">
                                    <img ngOptimizedImage
                                        src="https://res.cloudinary.com/afterbricks/image/upload/v1714294240/Final_27_Apr_mtxnan.png"
                                        alt="afterbricks youtube">
                                </div>
                                <div class="play-btn">
                                    <i class="fa-brands fa-youtube"></i>
                                    <div class="bg"></div>
                                </div>

                            </div>
                        </a>
                    </div>
                    
                    <a class="side3 side-bg" (click)="onBudget()" routerLink="cashback">
                        <img ngOptimizedImage
                        src="https://res.cloudinary.com/afterbricks/image/upload/v1723545812/homepage/Untitled_design_3_turfig.webp"
                        alt="budget">
                    </a>
                </div>
            </div> -->


            
            
            <!-- <div class="sample-banner p-0 m-block" style="background-image: url('https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/sample-bg_yeimfq.jpg');">
                <div class="sample-flex">
                <div class="sample-img">
                    <img src="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/sample-box_gvk5a8.webp" alt="sample box">
                </div>
                <div class="contant">
                    <h3>Order Free Samples Now – Quick & Easy!</h3>
                    <p>Experience the quality of materials. Request your free samples now.</p>
                    <ul>
                        <li>Wide selection</li>
                        <li>Fast delivery</li>
                        <li>Absolutely free
                        </li>
                    </ul>
                    <button (click)="_ds.samplesVisible=true">Order now!</button>
                    </div>
                </div>
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1737448640/sample-sec-mobile_1_hwgqzp.webp" alt="sample afterbricks">
                <button class="" (click)="_ds.samplesVisible=true">Let's explore</button>
            </div>  -->
            
        <div class="product-class-ses sec-gap-py sec-gap-pbm" id="find-by-budget" *ngIf="isBrowser">
            <div >
                <div class="heading-block text-center">
                    <h2>
                        Product categories by budget.
                    </h2>
                    <p>
                        Discover Pocket-Friendly Product Options Just for You
                    </p>
                </div>
                <div class="d-flex w-fit m-auto">
                    <button class="btn p-class-btn" [ngClass]="{'active-p-class-btn':is_most_economical}"
                        (click)="onProductClass(true,'economical')">Economical</button>
                    <button class="btn p-class-btn" [ngClass]="{'active-p-class-btn':is_standard_choice}"
                        (click)="onProductClass(true,'standard')">Standard</button>
                    <button class="btn p-class-btn" [ngClass]="{'active-p-class-btn':is_premium_product}"
                        (click)="onProductClass(true,'premium')">Premium</button>
                </div>
                <div class="sec-menu-stripe">
                    <ul>
                        <!-- <li class="active-ms" [ngClass]="{'active-ms':activeClassCatId==null}"
                        (click)="onProductClassCategpry(null)">All</li> -->
                        <li [title]="dep?.name" [ngClass]="{'active-ms':activeClassCatId===dep?.id}"
                            (click)="onProductClassCategpry(dep?.id)" *ngFor="let dep of departments_list">{{dep?.name}}
                        </li>
                    </ul>
                </div>
                <div class="ab-row-1">
                    <div class="card-1-2"
                        *ngFor="let populerProd of (showAllProducts ? class_wise_products : class_wise_products.slice(0, 4));let pi=index">
                        <div class="card-1-1-outer" [ngStyle]="{'background-color':populerProd.bgColor}"
                            [ngClass]="{'active-card-1-1-outer':pi===active_budget_index}">
                            <figcaption class="card-1-1-text">
                                <span>{{populerProd?.sub_category}}</span>
                                <!-- <p *ngIf="populerProd?.price_range?.min_price">Range </p> -->

                                <a class=" pt-budget-link" (click)="ctr('product_class',populerProd.id)"
                                    routerLink="./product/{{populerProd.main_category_slug_name}}"
                                    [queryParams]="getqueryParams(populerProd,pt)"
                                    title="{{pt?.name}} price range  &#8377;{{pt?.price_range?.min_price | number:'1.0-1'}} - &#8377;{{pt?.price_range?.max_price | number:'1.0-1'}}"
                                    *ngFor="let pt of populerProd?.slice_product_type_list"><p class="dots"></p>
                                    {{pt.name}}:
                                    <span>&#8377;{{pt?.price_range?.min_price |
                                        number:'1.0-1'}} - &#8377;{{pt?.price_range?.max_price | number:'1.0-1'}}</span>
                                </a>
                                <div class="slbtn"
                                    *ngIf="pi!==active_budget_index && (populerProd?.product_type_list?.length > 2)"
                                    (click)="showMoreTypes(pi,true)">Show more</div>
                                <div class="slbtn" *ngIf="pi===active_budget_index" (click)="showMoreTypes(pi,false)">
                                    Show
                                    less</div>
                            </figcaption>
                            <div class="card-1-1-img">
                                <img ngOptimizedImage [ngSrc]="populerProd?.image" width="120" height="120"
                                    [alt]="populerProd?.name" loading="lazy" />
                            </div>
                        </div>

                    </div>
                </div>
                <!-- <div class="d-flex justify-content-center sec-footer">
                    <button class="hm_btn" (click)="ProductCategoriesByBudget()"
                        *ngIf="!showAllProducts && class_wise_products?.length > 4">Show More Categories</button>
                </div> -->
            </div>
        </div>  
        </div>

        <!-- Recently -->
        <div id="recently-viewed" class="recently-viewed-sec sec-gap-py sec-gap-mb"
            *ngIf="recentlyViewedProducts?.length && !global_loader && isBrowser">
            <div class="ab-container heding-pading-eight">
                <div class="heading-block text-center">
                    <h2>Recently viewed products. </h2>
                </div>
                <div class="product-list">
                    <ul class="mb-0">
                        <li class="recently-viewed-product-card"
                            *ngFor="let prod of recentlyViewedProducts;let pi-index">
                            <a routerLink="./p/{{prod?.slug_name}}" target="_blank" [title]="prod?.name">
                                <div class="product-img">
                                    <img ngOptimizedImage [src]="prod?.image_list[0]?.image_url" [alt]="prod?.name">
                                </div>
                                <p class="recently-product-brand">{{prod?.brand}}</p>
                                
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- =========== Budget Tool ============ -->
     <div class="sec-gap-py">
        <div class="budget-section " *ngIf="isBrowser">
            <div class="ab-container sec-gap-py">
                <div class="heading-block  padding-top-eight text-center">
                    <h2>
                        A unique Budget optimizer. 
                    </h2>
                    <p>
                        Auto calculate approximate material cost as per your total budget & interior works
                    </p>
                </div>

                <div class="budget-strip"
                    *ngIf="(!global_loader && _as?.user_info?.projectInfo || getBudgetStatus()) && _as.isOnMobilePlatform">
                    <div class="bs-1">
                        <span>Your budget</span>
                        <p> &#x20B9;{{totalBudget?.toLocaleString('en-IN')}}</p>
                    </div>
                    <div class="bs-1">
                        <span>Total selected </span>
                        <p>{{work_list.length}} Tasks</p>
                    </div>
                </div>
                <div class="budget-white-sec" *ngIf="!_as?.user_info?.projectInfo && !getBudgetStatus()">
                    <div class="budget-section-card" >
                        <div class="fist-sec-content-img"
                            [ngClass]="{'tab-display':!(_homeservice.activeBudgetSec==='first-step')}"
                            *ngIf="(_homeservice.activeBudgetSec==='first-step') || !_as.isOnMobilePlatform">
                            <div class="bg90deg"></div>
                            <div class="budget-card-description w-block">
                                <div>
                                    <span>Spend as per your budget</span>
                                    <p class="w-block">Let us help you to renovate within your pocket
                                    </p>
                                </div>
                            </div>
                            <div class="fist-sec-budget-img">
                                <img ngOptimizedImage width="239" height="331"
                                    ngSrc="assets/images/home/thoughtful-looking-thinking.webp" alt="budget thinking"
                                    loading="lazy">
                                <div class="think-animation-box">
                                    <div class="hearts_wrapper">
                                        <a title="Budget" class="heart green">
                                            <div>Budget?</div>
                                        </a>
                                        <a title="Brands" class="heart pink">
                                            <div>Brand?</div>
                                        </a>
                                        <a title="Products" class="heart blue">
                                            <div>Product?</div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="first-act-card" *ngIf="_homeservice.activeBudgetSec==='first-step'">
                            <button (click)="onLetsStart()" title="Let's start">Let's start</button>
                        </div>
                        <div class="budget-card-action" *ngIf="_homeservice.activeBudgetSec!=='first-step'">
                            <h4>Smart renovation budget tool</h4>
                            <div class="budget-card-loader" *ngIf="is_budget_cal_loader">
                                <div class="loder-box">
                                    <div class="clock-loader"></div>
                                    <div class="loader-text">
                                        <span>Creating your house spaces, please wait ...</span>
                                    </div>
                                </div>
                            </div>
                            <ul class="steper">
                                <li [ngClass]="{'active-li':getStep() >=1}">1</li>
                                <li [ngClass]="{'active-li':getStep() >=2}">2</li>
                                <li [ngClass]="{'active-li':getStep() >=3}">3</li>
                                <li [ngClass]="{'active-li':getStep() >=4}">4</li>
                            </ul>
                            <div class="budget-card-header-strip">
                                <span class="title one-step-house-typ"
                                    *ngIf="_homeservice.activeBudgetSec==='slHType'">Please
                                    select your house type</span>
                                <span class="title" *ngIf="_homeservice.activeBudgetSec==='slSpace'">Please select your
                                    house bedrooms type</span>
                                <span class="title" *ngIf="_homeservice.activeBudgetSec==='slArea'">What is the carpet
                                    area of your house?
                                </span>
                                <span class="title" *ngIf="_homeservice.activeBudgetSec==='slCity'">In which city is your
                                    house located?</span>
                            </div>
                            <!-- [@animSlider]="{ value: state, params: { direction: direction } }" -->
                            <ul class="budget-card-action-ht-ul" *ngIf="_homeservice.activeBudgetSec==='slHType'"
                               >
                                <li>
                                    <button class="budget-ht-crad"
                                        (click)="_homeservice.onHouseType('independenthouse')"
                                        [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='independenthouse'}"
                                        title="Independent House">
                                        <div class="budget-ht-crad-img">
                                            <img ngOptimizedImage width="52" height="52"
                                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708746/icon-1_heastp.png"
                                                alt="Independent House" loading="lazy">
                                        </div>
                                        <span>House</span>
                                    </button>
                                </li>
                                <li>
                                    <button class="budget-ht-crad" (click)="_homeservice.onHouseType('apertment')"
                                        [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='apertment'}"
                                        title="Apartments">
                                        <div class="budget-ht-crad-img">
                                            <img ngOptimizedImage width="52" height="52"
                                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708701/icon-2_i46qoc.png"
                                                alt="Apartments" loading="lazy">
                                        </div>
                                        <span>Apartments</span>
                                    </button>
                                </li>
                            </ul>
                            <ul class="budget-card-action-space-ul" *ngIf="_homeservice.activeBudgetSec==='slSpace'" >
                                <ng-container *ngFor="let ht of hometypes;">
                                    <li *ngIf="hometypes?.length">
                                        <button class="spaces-ul-card" (click)="valueChange(ht)" [title]="ht?.name"
                                            [ngClass]="{'active-card-loader':ht.id===_homeservice.htype?.id}">
                                            <img ngOptimizedImage  [ngSrc]="ht?.icon" [alt]="ht?.name" loading="lazy">
                                            <span>{{ht?.name}}</span>
                                        </button>
                                    </li>
                                </ng-container>
                                <ng-container *ngFor="let ht of [1,2,3,4,5,6,7];">
                                    <li class="is-loading" style="height:50px" *ngIf="!hometypes?.length">
                                        <div class="card-loader"> </div>
                                    </li>
                                </ng-container>
                            </ul>
                            <form [formGroup]="infoForm" *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'">
                                <div class="wt-block ">
                                    <div class="form-group">
                                        <div class="area-img" *ngIf="_homeservice.activeBudgetSec==='slArea'">
                                            <img ngOptimizedImage width="40" height="40"
                                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1690549438/icons/area_dmewig.png"
                                                alt="area" loading="lazy">
                                        </div>
                                        <div class="input-group mb-2 col-md-6 col-sm-12 p-0">
                                            <p-inputNumber [style]="{width:'100%',}" formControlName="area"
                                                inputId="locale-indian" mode="decimal" locale="en-IN" currency="INR"
                                                placeholder="Enter carpet area" prefix="sqft "> </p-inputNumber>
                                            <div class="error-carpet" *ngIf="(submitted && info['area']?.errors)">
                                                <div class="error_arrow_box">
                                                    <div class="erro-1"
                                                        *ngIf="submitted && info['area']?.errors?.['required'] ">
                                                        Carpet area required
                                                    </div>
                                                    <div class="erro-2"
                                                        *ngIf="submitted && info['area']?.errors?.['min']">
                                                        Minimum carpet area {{minval}} sqft required
                                                    </div>
                                                    <div class="erro-2"
                                                        *ngIf="submitted && info['area']?.errors?.['max']">
                                                        Maximum carpet area {{maxval}} sqft</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="m-block">
                                    <div class="form-group" >
                                        <div class="area-img" *ngIf="_homeservice.activeBudgetSec==='slArea'">
                                            <img ngOptimizedImage width="40" height="40"
                                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1690549438/icons/area_dmewig.png"
                                                alt="area icon" loading="lazy">
                                        </div>
                                        <div class="input-group mb-2 col-md-6 col-sm-12 p-0">
                                            <p-inputNumber [style]="{width:'100%',}" formControlName="area"
                                                inputId="locale-indian" mode="decimal" locale="en-IN"
                                                placeholder="Enter carpet area" prefix="sqft "> </p-inputNumber>
                                            <div class="error-carpet" *ngIf="(submitted && info['area']?.errors)">
                                                <div class="error_arrow_box">
                                                    <div class="erro-1"
                                                        *ngIf="submitted && info['area']?.errors?.['required'] ">
                                                        Carpet area required
                                                    </div>
                                                    <div class="erro-2"
                                                        *ngIf="submitted && info['area']?.errors?.['min']">
                                                        Minimum carpet area {{minval}} sqft required
                                                    </div>
                                                    <div class="erro-2"
                                                        *ngIf="submitted && info['area']?.errors?.['max']">
                                                        Maximum carpet area {{maxval}} sqft</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </form>
                            <ul class="budget-card-action-sl-ul" *ngIf="_homeservice.activeBudgetSec==='slCity'"
                            >
                                <ng-container *ngFor="let city of citys;let index=index">
                                    <li *ngIf="citys?.length">
                                        <button class="budget-sl-crad" (click)="onSelectBudgetCity(index)"
                                            [title]="city?.name">
                                            <img ngOptimizedImage width="38" height="38" [ngSrc]="city?.icon"
                                                [alt]="city?.name" loading="lazy">
                                            <span>{{city?.name}}</span>
                                        </button>
                                    </li>
                                </ng-container>
                                <ng-container *ngFor="let city of [1,2,3,4,5]">
                                    <li class="is-loading" *ngIf="!citys?.length">
                                        <div class="budget-sl-crad"></div>
                                    </li>
                                </ng-container>
                            </ul>
                            <div class="budget-footer budget-footer-mob"
                                *ngIf="( _homeservice.activeBudgetSec !== 'slHType') || (pageLoad && _homeservice.activeBudgetSec==='slArea')">
                                <button class="bug-back bug-back-hm" *ngIf="_homeservice.activeBudgetSec !== 'slHType'"
                                    (click)="_homeservice.onBack()" title="back"><i class="fa-solid fa-angle-left"></i>
                                    Back
                                </button>
                                <button *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'" title="Next"
                                    (click)="onSubmitinfo()">Next <i class="fa-solid fa-angle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="budget-section-card" *ngIf="_as?.user_info?.projectInfo?.is_active || getBudgetStatus()">
                    <div class="budget-scroll-mob">
                        <div class="budget-card-description w-block" style="background-color: #d3d3d3bf;">
                            <div>
                                <span style="color: #222;">Allocated expense to each task</span>
                                <p style="color: #222;">Now stay within your pocket, we have allocated your
                                    overall budget among each room & each task accordingly!
                                </p>
                            </div>
                        </div>
                        <div class="budget-card-action work-sec work-sec-mob">
                            <div class="budget-scroll-tab">
                                <div class="budget-strip" *ngIf="!global_loader && !_as.isOnMobilePlatform">
                                    <div class="bs-1">
                                        <span>Your budget:</span>
                                        <p> &#x20B9;{{totalBudget?.toLocaleString('en-IN')}}</p>
                                    </div>
                                    <div class="bs-1">
                                        <span>Total selected:</span>
                                        <p>{{work_list.length}} Tasks</p>
                                    </div>
                                </div>
                                <ul class="work-budget-card-ul" *ngIf="!global_loader">
                                    <li *ngFor="let work of work_list;let i=index" (click)="onSelectWork(i)">
                                        <div class="work-card">
                                            <div class="work-img">
                                                <img ngOptimizedImage width="56" height="56" [ngSrc]="work?.image_url"
                                                    [alt]="work?.name" lazyLoad="lazy">
                                            </div>
                                            <div class="work-budget">
                                                <span *ngIf="work?.amount">&#x20B9;
                                                    {{work?.amount?.toLocaleString('en-IN')}}</span>
                                                <span *ngIf="!work?.amount">&#x20B9; xxxxxx</span>
                                                <p>{{work?.name}}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul class="work-budget-card-ul is-loading" *ngIf="global_loader">
                                    <li *ngFor="let work of work_list">
                                        <div class="work-card product-img-1" style="height: 99px;">
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-block">
                    <hr>
                </div>
                <p class="budget-note mt-block" style="margin-top: 8px;margin-bottom: 16px;">Note: These are broad
                    estimates
                    & can vary depending upon your specific design choice. The precise figures will be determined by
                    your
                    interior designer. </p>
            </div>
        </div>
     </div>

        <!-- <div class="sec-gap-py">
            <div class="ab-container" *ngIf=" isBrowser">
            <div class="sample-banner w-block wt-block" style="background-image: url('https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/sample-bg_yeimfq.jpg');">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 800" preserveAspectRatio="none" class="absolute left-0 top-0 min-h-screen min-w-screen"><rect  fill="var(--primary-500)"></rect><path d="M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z" fill="var(--primary-400)"></path><path d="M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z" fill="var(--primary-300)"></path><path d="M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z" fill="var(--primary-200)"></path><path d="M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z" fill="var(--primary-100)"></path></svg>
                <img src="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Lets_Grow_1_1_lc1wf0.webp" alt="sample afterbricks">
                <div class="sample-flex">
                <div class="contant">
                    <h3>Order Free Samples Now – Quick & Easy!</h3>
                    <p>Experience the quality of materials. Request your free samples now.</p>
                    <ul>
                        <li>Wide selection</li>
                        <li>Fast delivery</li>
                        <li>Absolutely free
                        </li>
                    </ul>
                    <button (click)="_ds.samplesVisible=true">Order now!</button>
                </div>
                <div class="sample-img">
                    <img src="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/sample-box_gvk5a8.webp" alt="sample box">
                </div>
                </div>
            </div>

           
            <div class="w-block w-100">
                <div class="budget-new-launches-brand-section">
                <ul>
                    <li>
                     <button (click)="onFindByBudgetClick()">
                        <img ngOptimizedImage width="18" height="18" 
                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/budget_xvqv0c.png" alt="budget" loading="lazy">
                        <span>Search material by budget</span>
                     </button>
                    </li>
                    <li>
                    <button (click)="onNewLaunchesClick()">
                        <img ngOptimizedImage width="18" height="18"
                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/shuttle_rgc5h6.png" alt="new-launches" loading="lazy">
                        <span>New-launches</span>
                    </button>
                    </li>
                    <li>
                       <button *ngIf="brand_list?.length" routerLink="./brand">
                        <img ngOptimizedImage width="18" height="18"
                        ngSrc="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/apartment_h62pbp.png" alt="Brand & manufacturer" loading="lazy">
                        <span>Brand & manufacturer</span>
                       </button>
                    </li>
                </ul>
             </div>
            </div>
            </div>
        </div> -->
            <!-- Individual brand section- -->
                        <div class=" sec-gap-py">
                            <div class="individual-brand-sec" *ngIf="isBrowser">
                            <div class="ab-container">
                                <div class="heading-block text-center">
                                    <h2>
                                        Brands of the month.
                                    </h2>
                                    <p>
                                        Explore spectacular product collections from trusted Brands to Ignite Your Inspiring Projects
                                    </p>
                                </div>
                              <div class="marquee individual-brand-marquee">
                               <div class="marquee__content">
                                <ul class="individual-brand list-inline">
                                    <li class="individual-brand-card" *ngFor="let indvid of Individual_brand;let oi=index">
                                        <a class="p-card-i" [routerLink]="indvid.link" title="{{indvid.title}} {{indvid?.brand}}">
                                            <div class="fig-caption ">
                                                <h2 class="text-shodow-2 text-white">{{indvid.title}}</h2>
                                                <p class="text-shodow-2 text-white">{{indvid.sub_title}}</p>
                                            </div>
                                            <img ngOptimizedImage [ngSrc]="indvid.imgurl" [alt]="indvid?.altText" style="width: 100%;"
                                                width="460" height="300" loading="lazy">
                                        </a>
                                    </li>
                                </ul>
                               </div>
                              </div>
                            </div>
                        </div>
                        </div>
                        <!-- End Individual brand section -->
                <div class=" sec-gap-py" *ngIf="isBrowser">
                    <div class="ab-container">
                        <div class="heading-block  padding-top-eight text-center">
                            <h2>
                                Interior professionals & designers.
                            </h2>
                            <p>
                                Meet 155 professionals & connect them instantly
                            </p> 
                        </div>
                        <div class="professionals-list" *ngIf="!is_professionloader">
                            <div class="wt-block">
                                <owl-carousel-o [options]="_owlservice.owlHomecard">
                                    <ng-container *ngFor="let pro of displayedProfession_list;let i = index">
                                        <ng-template carouselSlide [dataMerge]="i+1">
                                            <div class="plc">
                                                <a class="plca" routerLink="/service-provider/{{pro.slug_name}}"
                                                    [title]="pro?.name">
                                                    <div class="cover-pic" style="background-image: url({{pro?.banner_pic}});">
                                                        <div class="plca-icon">
                                                            <img ngOptimizedImage width="74" height="74"
                                                                [alt]="pro?.business_name" [ngSrc]="pro?.icon_url"
                                                                loading="lazy">
                                                        </div>
                                                    </div>
        
                                                    <div class="plcat">
                                                        <span>{{pro?.profession_type}}</span>
                                                        <h3 *ngIf="pro?.business_name">{{pro?.business_name}}</h3>
                                                        <h3 *ngIf="!pro?.business_name">{{pro?.name}} {{pro?.last_name}}</h3>
        
                                                        <div class="p-address">
                                                            <p> {{pro?.address?.address2}}, {{pro?.address?.city}},
                                                                {{pro?.address?.state}} <span
                                                                    *ngIf="pro?.address?.pincode">({{pro?.address?.pincode}})</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </owl-carousel-o>
                            </div>
                            <div class="m-block">
                                <ul class="carousel-mobile">
                                    <li *ngFor="let pro of displayedProfession_list;let i = index">
                                        <div class="plc">
                                            <a class="plca" routerLink="/service-provider/{{pro.slug_name}}"
                                                [title]="pro?.name">
                                                <div class="cover-pic" style="background-image: url({{pro?.banner_pic}});">
                                                    <div class="plca-icon">
                                                        <img ngOptimizedImage width="74" height="74" [alt]="pro?.business_name"
                                                            [ngSrc]="pro?.icon_url" loading="lazy">
        
                                                    </div>
                                                </div>
                                                <div class="plcat">
                                                    <span>{{pro?.profession_type}}</span>
                                                    <h3 *ngIf="pro?.business_name">{{pro?.business_name}}</h3>
                                                    <h3 *ngIf="!pro?.business_name">{{pro?.name}} {{pro?.last_name}}</h3>
        
                                                    <div class="p-address">
                                                        <p> {{pro?.address?.address2}}, {{pro?.address?.city}},
                                                            {{pro?.address?.state}} <span
                                                                *ngIf="pro?.address?.pincode">({{pro?.address?.pincode}})</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div *ngIf="is_professionloader">
                            <ng-container>
                                <!---------loader starts--------------->
                                <ul class="loader-ul">
                                    <ng-container *ngFor="let ht of [1,2,3,4];">
                                        <li class="is-loading">
                                            <div class="card-loader ">
                                                <div class="card-loader-img shimmerBG"></div>
                                                <span class="shimmerBG"></span>
                                                <div class="shimmerBG content-line"></div>
                                                <div class="shimmerBG content-line"></div>
        
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>
                                <!---------loader ends--------------->
                            </ng-container>
                        </div>
                        <div class="d-flex justify-content-center padding-bottom-eight sec-footer" *ngIf="!is_professionloader">
                            <a title="Interior professionals & designers" routerLink="./service-provider" class="hm_btn"> View
                                All
                            </a>
                        </div>
                    </div>
                       
                </div>
                <div class="sec-gap-py" >
                    <div class="new-products sec-gap-py" id="new-lunch-product" *ngIf="isBrowser">
                    <div class="ab-container">
                        <div class="heading-block text-center">
                            <h2>
                                Keep in the Loop with new product trends. 
                            </h2>
                            <!-- <p>
                            Stay updated on trends. projects and the latest collections from brands and designers
                        </p> -->
                        </div>
                        <div class="ab-row-2">
                            <div class="product-card-full" *ngFor="let newprodu of newlaunchedproducts;let ni=index">
                                <a routerLink="./p/{{newprodu.slug_name}}" [title]="newprodu?.name"
                                    (click)="ctr('new_launch',newprodu.id)">
                                    <div class="pc-img">
                                        <img ngOptimizedImage width="523" height="423" [ngSrc]="newprodu?.image"
                                            [alt]="newprodu?.name" loading="lazy">
                                    </div>
                                    <div class="pc-text new-trand-p-r">
                                        <span>{{newprodu?.brand_name}}</span>
                                        <h2>{{newprodu?.name}}</h2>
                                        <p>{{newprodu?.short_description}}</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="d-flex justify-content-center sec-footer">
                        <button class="hm_btn">Show more</button>
                    </div> -->
                </div>
            </div>

        <div class="w-block   w-100">
          <div class="ab-container">
            <div class="architects-designers-Manufacturers-Section">
                <!-- Architects and Designers Section -->
                <div class="card">
                  <h2>For architects and interior designers</h2>
                  <ul>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                    style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                    <span>Search and explore from leading brands.</span>
                  </li>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                    style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                    <span>Compare prices and find availability.</span>
                    </li>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Negotiate discounts directly.</span>
                     </li>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                    style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                    <span>Get material samples delivered on-site.</span>
                    </li>
                    <li>
                    <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Free for architects and designers.</span>
                     </li>
                    <div class="image-architects-designers-Manufacturers">
                        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1732536634/interior_designer_r9hxdy.webp" alt="Architects and Designers">
                      </div>
                  </ul>
                  <!-- (click)="_homeservice.isdisplybrandpopup = true;" -->
                  <button (click)="joinaspro()">Join as Pro</button>
                </div>
            
                <!-- Manufacturers Section -->
                <div class="card">
                 
                  <h2>For manufacturers</h2>
                  <ul>
                    <li>
                     <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Hundreds of new interior designers every month</span>
                     </li>
                    <li>
                    <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Instant leads from specifiers</span>
                    </li>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                    style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                    <span>Sell out fast to increase sales thru primary channels</span>
                    </li>
                    <li>
                     <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" >
                    <span>Fast sample delivery</span>
                    </li>
                    <li>
                    <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Gain massive brand visibility and a strong ROI.</span>
                     </li>
                    <div class="image-architects-designers-Manufacturers">
                        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1732536654/Manufacture_qmgbrj.webp" alt="Manufacturers">
                      </div>
                  </ul>
                  <button (click)="onBrandRegistration()">Become a Brand Partner</button>
                </div>
              </div>
          </div>
            


            
            <!-- <div class="youtube-container sec-gap-mb mb-0">
                <div class="side1 side-bg cursor-pointer" (click)="_homeservice.isdisplybrandpopup = true;">
                    <div class="fs-card">
                        <img ngOptimizedImage
                            src="https://res.cloudinary.com/afterbricks/image/upload/v1726309354/Web_bifrni.webp"
                            alt="explore" loading="lazy">
                    </div>
                </div>
                <div class="side2 side-bg">
                    <a class="vd-card" href="https://youtu.be/t3hpjFHOgNM" target="_blank" title=" What we do?">
                        <div class="eve-title">
                            <div class="fs-card">
                                <img ngOptimizedImage
                                    src="https://res.cloudinary.com/afterbricks/image/upload/v1705919334/home_page_web_banners_uxui5q.webp"
                                    alt="vd-card" loading="lazy">
                            </div>
                            <div class="play-btn">
                                <i class="fa-brands fa-youtube"></i>
                                <div class="bg"></div>
                            </div>

                        </div>
                    </a>
                </div>
                <div class="side3 side-bg">
                    <a class="fs-card" (click)="onBudget()">
                        <img ngOptimizedImage
                            src="https://res.cloudinary.com/afterbricks/image/upload/v1723544281/homepage/19_u1pxk2.webp"
                            alt="budget" loading="lazy">
                    </a>
                </div>
            </div> -->
        </div>
        
      <!-- <div class="w-block">
        <div class="invite-strip ">
            <div class=" join-pro-bt-bak">
                <button title="Join Us" (click)="joinaspro()">
                    Join us as a Pro
                    <span>Sign up in few steps</span>
                </button>

            </div>
            <div class="exhibit-joinButton">
                <button (click)="onBrandRegistration()" title="Exhibit with Us">
                    Exhibit with Us
                    <span>Sign up in few steps</span>
                </button>
              </div> 
        </div>
      </div> -->
      <div class="m-block ab-container">
        <div class=" px-0">
        <div class="architects-designers-Manufacturers-Section">
            <!-- Architects and Designers Section -->
            <div class="card">
              <h2>For architects and interior designers</h2>
              <ul>
                <li>
                <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                <span>Search and explore from leading brands.</span>
            </li>
                <li>
                <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                <span>Compare prices and find availability.</span>
                </li>
                <li>
                <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                 style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                 <span>Negotiate discounts directly.</span>
                 </li>
                <li>
                <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                <span>Get material samples delivered on-site.</span>
                </li>
                <li>
                <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                 style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                 <span>Free for architects and designers.</span>
                 </li>
                <div class="image-architects-designers-Manufacturers">
                    <img src="https://res.cloudinary.com/afterbricks/image/upload/v1732536634/interior_designer_r9hxdy.webp" alt="Architects and Designers">
                  </div>
              </ul>
              <button (click)="joinaspro()">Join as Pro</button>
            </div>
                        <!-- Manufacturers Section -->
                <div class="card">
                 
                  <h2>For manufacturers</h2>
                  <ul>
                    <li>
                     <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Hundreds of new interior designers every month</span>
                     </li>
                    <li>
                    <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Instant leads from specifiers</span>
                    </li>
                    <li>
                    <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                    style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                    <span>Sell out fast to increase sales thru primary channels</span>
                    </li>
                    <li>
                     <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" >
                    <span>Fast sample delivery</span>
                    </li>
                    <li>
                    <img class="check-img"src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                     style="width: 13px; height:13px;margin-right: 8px;" alt="tick">
                     <span>Gain massive brand visibility and a strong ROI.</span>
                     </li>
                    <div class="image-architects-designers-Manufacturers">
                        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1732536654/Manufacture_qmgbrj.webp" alt="Manufacturers">
                      </div>
                  </ul>
                  <button (click)="onBrandRegistration()">Become a Brand Partner</button>
                </div>
        </div>
    </div>
     <!-- <div class="gray-sec ab-bc sec-gap-py pb-0" *ngIf="isBrowser">
            <div class="ab-container px-0 py-0">
                <div class="mt-block ">
                    <div class="invite-strip-sec invite-strip-sec-mb">
                        <div class=" join-pro-bt-bak">
                            <button (click)="onBrandRegistration()" title="Exhibit with Us"style="font-size: 14px;">
                                Exhibit with Us
                                <span style="font-size: 12px;">Sign up in few steps</span>
                            </button>

                        </div>
                        <div class=" join-pro-bt-bak">
                            <button title="Join Us" (click)="joinaspro()" style="font-size: 14px;">
                                 Join us as a Pro
                                <span style="font-size: 12px;">Sign up in few steps</span>
                             </button>
                        </div>
                   </div>
              </div>
          </div>
     </div> -->
    </div>
        <div class="supercharge-your-workflow-sec">
            <div class="ab-container">
            <div class="card-supercharge">
              <div class="supercharge-card">
                <h2>Save ideas and book samples for later.</h2>
                <ul>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Curate and categorize materials by creating personalized boards.</span>
                    </li>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Seamlessly collaborate with your team in real-time.</span>
                    </li>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Request samples for your entire board with just a few clicks.</span>
                    </li>
                </ul>
                <div class="Streamline-video">
                    <video #videoPlayer width="100%" id="homepage-video" 
                    class="cmsp53-max-lg:hidden cmsp53-w-full cmsp53-h-full cmsp53-border cmsp53-border-solid cmsp53-border-mbgray-110 cmsp53-rounded-[20px] cmsp53-shadow-lvl3" 
                    poster="https://res.cloudinary.com/afterbricks/image/upload/v1738391914/Order_Sample_Process_dtmv7i.png"
                    preload="auto" loop autoplay muted playsinline>
                    <source class="cmsp53-max-lg:hidden" 
                        src="https://res.cloudinary.com/afterbricks/video/upload/v1738677046/Final_Sample_process_2_fstogz.mp4"  
                        type="video/mp4">
                    </video>
                   </div>
              </div>
              <div class="supercharge-card">
                <h2>Engage Directly with Brand Representatives
                </h2>
                <ul>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Centralize all your communications, easy-to-access platform.</span>
                    </li>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Access representatives from a wide range of top-tier brands.</span>
                    </li>
                    <li>
                        <img class="check-img" src="https://res.cloudinary.com/afterbricks/image/upload/v1732274959/tick_baaxcl.png"
                        style="width: 13px; height:13px;margin-right: 8px;margin-top: 8px;" alt="tick">
                        <span>Obtain specifications, timelines and quotes effortlessly.</span>
                    </li>
                </ul>
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1738659628/Final_Sample_process_1_ue49pd.png" alt="Save Materials" />
              </div>
            </div>
            </div>
        </div>
        <!-- end -->
   

       
        <div class="how-it-work-sec sec-gap-py d-none" *ngIf="isBrowser">
            <div class="ab-container">
                <div class="heading-block padding-top-eight text-center">
                    <h2>
                        How it works.
                    </h2>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6  px-0  why-pr">
                        <ol class="ab-process">
                            <li class="process_item" *ngFor="let step of howitworksptes;let si=index">
                                <div class="process__number" [ngClass]="{'active-process__number':si<=activeStepindex}">
                                    <span>{{si+1}}</span>
                                </div>
                                <div class="process_body">
                                    <h3>{{step.msgTitle}}</h3>
                                    <p>{{step.msg}}</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                    <div class="col-6 pr-0 w-block">
                        <div class="active-step-img  ">
                            <img ngOptimizedImage width="659" height="379"
                                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1670847889/homepage/Why_choose_Afterbricks_e9jca8.webp"
                                alt="wca" loading="lazy">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="professional-regiter-strip sec-gap-py" style="padding-top: 0 !important;" *ngIf="isBrowser">
            <div class="ab-container">
                <section class="ai-strip-section">
                    <img ngOptimizedImage width="62" height="62"
                        ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1707667412/AI_lxncze.png"
                        alt="AI icon" loading="lazy">
                    <div>
                        <p><b>Coming soon -</b> AI-driven recommendations for product selection based on your design
                            preferences
                            and budget constraints</p>
                    </div>
                </section>
            </div>
        </div> -->
        <div class="ab-container sec-gap-py">
            <div class=" text-panel-sec ">
            <div class="ab-container mobl">
                <h2>India's largest online material exhibition.</h2>
                <p>Introducing Afterbricks, your ultimate destination for interior fitting & finishing products! This
                    innovative platform caters to professionals like interior designers, architects, contractors, and
                    skilled persons, creating a harmonious ecosystem that connects stakeholders seamlessly.</p>
                <p>Crafting a truly inviting and functional home environment entails meticulous attention to every
                    aspect,
                    from foundational elements to finishing touches. <a
                        title="“Nitco” Discover The Trends In Tiles And Flooring For A Fresh New Look!"
                        routerLink="./department/tiles-flooring">Tiles and flooring</a> serve as the groundwork of
                    interior design, not only providing durability but also establishing the aesthetic foundation of a
                    space. <a title="Virgo, Duro” Elevate Your Space With Our Exquisite Woodwork Creations"
                        routerLink="./department/woodwork">Woodwork</a> introduces a sense of warmth and character,
                    adding
                    depth and texture to the
                    surroundings. From trimmings to <a title="">cabinets</a>, wood accents contribute to the overall
                    visual
                    appeal while
                    offering practical storage solutions.</p>
                <p><a title="“Hafele, Ozone” Unlocking your home’s potential piece by piece!!!"
                        routerLink="./department/hardware">Hardware</a> accessories for doors play a pivotal role in
                    enhancing both style and functionality. <a title="“Dorset , Ozon”,  Unlock style and security"
                        routerLink="./d/hardware/handles-locks">Handles,
                        locks,</a> <a routerLink="./product/hardware" title="smart locks"
                        [queryParams]="getproductpagequeryParams('smart-locks')">smart locks</a> and <a
                        routerLink="./product/hardware" title="Hardware accessories hinges"
                        [queryParams]="getproductpagequeryParams('hinges')">hinges</a> not only secure entryways but
                    also
                    serve as subtle design elements that
                    complement the overall aesthetic. </p>
                <p>Smart <a routerLink="./department/fans"
                        title="“Atomberg” Beat The Heat With The Perfect Fan To Suit Your Style And Needs!">fans</a>
                    represent a modern approach to home comfort, offering intelligent features such as remote
                    control operation, programmable settings, and energy-efficient functionality. Also selecting the
                    best
                    <a routerLink="./department/paint-polish"
                        title="“Nippon” Revitalize Your Space With A Splash Of Color And Shine!">paint and polish</a> is
                    essential for preserving and enhancing surfaces throughout the home.
                </p>
                <p>The kitchen, often considered the heart of the home, benefits greatly from a modular design approach.
                    <a routerLink="./department/modular-kitchen"
                        title="“Hacker” Take Your Culinary Journey to New Heights!!">Modular kitchens</a> maximize space
                    efficiency and organization, incorporating customizable components that
                    adapt to the homeowner's needs and preferences.
                </p>
                <p><a routerLink="./department/lighting"
                        title="“Philips” Light Up Your World With Stunning Illumination!">Lighting</a> serves as a
                    cornerstone of interior design, shaping the mood and ambiance of each room.
                    Thoughtfully curated lighting fixtures can accentuate architectural features, highlight focal
                    points,
                    and create inviting atmospheres. From pendant lights to recessed fixtures, the strategic placement
                    and
                    selection of lighting elements can dramatically enhance the visual appeal and functionality of a
                    space.
                </p>
                <p><a routerLink="./department/bathroom-fittings"
                        title="”Hindware, Cera” Elevate Your Bathroom Experience With Our Premium Fittings, Where Luxury Meets Functionality Effortlessly.">Bath
                        fittings</a> and faucets combine practicality with elegance, elevating everyday routines with
                    their
                    sleek designs and reliable performance. From luxurious shower systems to contemporary sink fixtures,
                    bath fittings serve as focal points while enhancing the overall aesthetic of bathrooms.</p>
                <p>In conclusion, the essence of a well-crafted home lies in the seamless integration of various
                    elements,
                    each contributing to its overall functionality, comfort, and aesthetic appeal. From tiles and
                    flooring
                    to smart locks and lighting, every detail reflects a commitment to quality and design excellence,
                    creating spaces that resonate with style, sophistication, and timeless elegance.</p>
            </div>
        </div>
        </div>
        <div class="basic-info-popup" *ngIf="isBrowser">
            <p-sidebar [(visible)]="visibleSidebarCore" position="bottom" [showCloseIcon]="false" [blockScroll]="true"
                [baseZIndex]="10000" (onHide)="onBackSlider()">
                <div>
                    <div class="ab-modal-heading">
                        <svg (click)="onBackSlider()" width="20" height="20" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 2.66683L10.6666 1.3335L4 8.00015L10.6667 14.6668L12 13.3335L6.66666 8.00015L12 2.66683Z"
                                fill="#222" />
                        </svg>
                        <div *ngIf="activeCoreSubCategory">
                            <div class="d-flex" style="align-items: center;">
                                <img ngOptimizedImage width="55" height="55" style="height: 55px;"
                                    [ngSrc]="_ds.departments_list[activermainoptionsindex]?.icon"
                                    [alt]="_ds.departments_list[activermainoptionsindex]?.name" loading="lazy">
                                <h3>{{_ds.departments_list[activermainoptionsindex]?.name}}</h3>
                            </div>
                        </div>
                        <div *ngIf="!activeCoreSubCategory">
                            <div class="d-flex">
                                <img ngOptimizedImage width="55" height="55" *ngIf="getIcon()" [ngSrc]="getIcon()"
                                    alt="Product" loading="lazy">
                                <h3>{{getOptionHeading()}}</h3>
                            </div>

                        </div>
                    </div>
                    <div class="core-option-mobile-body">
                        <div class="departments-popover"
                            *ngIf="(active_option==='product' || active_option==='manufacturer' || active_option==='dealer' || active_option==='articl') && (!activeCoreSubCategory)">
                            <div class="d-item" [ngClass]="{'active-item':activermainoptionsindex===mci}"
                                (click)="mainCategoryoption(mci)" *ngFor="let main of active_categorys;let mci=index">
                                <img ngOptimizedImage width="40" height="40" [ngSrc]="main?.icon" [alt]="main.name"
                                    loading="lazy">
                                <span>{{main?.name}}</span>
                            </div>
                        </div>
                        <ul *ngIf="active_option==='professional' && !activeCoreSubCategory"
                            style="padding-left: 16px; padding-right: 16px;">
                            <li *ngFor="let prof of pro_types;let pi=index">
                                <a class="main-works" (click)="onProfessional(prof,pi)"
                                    [ngClass]="{'active-main-work':pi===activeprofTypeindex}" [title]="prof?.name">
                                    <div class="blank-circle" [ngClass]="{'active-circle':pi===activeprofTypeindex}">
                                    </div>
                                    <div>{{prof?.name}}</div>
                                </a>
                            </li>
                        </ul>
                        <div class="sub-categorys-sec" *ngIf="activeCoreSubCategory">

                            <div class="sub-categorys" *ngIf="active_option==='product' && activeCoreSubCategory">
                                <!-- (click)="onProduct(sub.id)" -->
                                <a class="sub-cat-link" [ngClass]="{'ab-pointer-events': sub?.is_coming_soon}"
                                    [title]="sub.name"
                                    *ngFor="let sub of _ds.departments_list[activermainoptionsindex]?.sub_category_list;let mci=index;let last=last"
                                    routerLink="./d/{{_ds.departments_list[activermainoptionsindex]?.slug_name}}/{{sub.slug_name}}">
                                    <img ngOptimizedImage width="60" height="60" *ngIf="sub.icon" [ngSrc]="sub?.icon"
                                        [alt]="sub?.name" loading="lazy">
                                    <p> {{sub.name}}</p>
                                </a>
                            </div>
                            <div class="sub-categorys" *ngIf="active_option==='manufacturer' && category_brand_load">
                                <a class="sub-cat-link brd-crd-pad" routerLink="./brand/{{brand?.slug_name}}"
                                    [title]="brand?.brand_name"
                                    *ngFor="let brand of category_brand_list;let mci=index;let last=last">
                                    <img class="h32" ngOptimizedImage width="97" height="60" [ngSrc]="brand?.logo"
                                        [alt]="brand?.brand_name" loading="lazy">
                                </a>
                            </div>
                            <div class="sub-categorys" *ngIf="active_option==='dealer'">
                                <a class="sub-cat-link" routerLink="./dealer"
                                    [queryParams]="{ mcId:_ds.departments_list[activermainoptionsindex].id,cityId :city.id}"
                                    [title]="city?.name" *ngFor="let city of dealer_citys;let mci=index;let last=last">
                                    <img ngOptimizedImage width="40" height="40" [ngSrc]="city?.icon_url"
                                        [alt]="city?.name" class="ct-icon-h40" loading="lazy">
                                    <p class="mt-8px"> {{city.name}}</p>
                                </a>
                            </div>
                            <div class="sub-categorys" *ngIf="active_option==='professional'">
                                <a class="sub-cat-link" (click)="onSelectCity(city)"
                                    *ngFor="let city of prof_locations;let pli=index;let last=last">
                                    <img ngOptimizedImage width="40" height="40" [ngSrc]="city?.icon_url"
                                        [alt]="city?.name" class="ct-icon-h40" loading="lazy">
                                    <p class="mt-8px"> {{city.name}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </p-sidebar>
        </div>
    <div *ngIf="isBrowser">
        <app-footer></app-footer>
        <!-- <app-new-footer></app-new-footer> -->
    </div>
    

<!---------web Budget Popup -------->
<!-- [position]="positionBudget" -->
<div class="bud-pop-web" *ngIf="!isOnMobilePlatform && isBrowser">
    <p-dialog [(visible)]="_as.isDisplayBudget" [modal]="true" header="" [draggable]="false" [resizable]="false"
         [style]="{ width: '750px'}">
        <!-- *ngIf="showCross" -->
        <div class="close-popup" (click)="closeBudgetPopup()">
            <img ngOptimizedImage ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="budget"
                loading="lazy" width="20" height="20">
        </div>
        <div class="budget-popup-box">

            <span class="sec-head" *ngIf="_homeservice.activeBudgetSec==='first-step'">Spend as per your
                budget</span>
            <p class="sub-sec-heading" *ngIf="_homeservice.activeBudgetSec==='first-step'">Let us help you to
                renovate
                within your pocket</p>
            <div class="budget-section-card budget-section-card-url"
                *ngIf="!_as?.user_info?.projectInfo && !getBudgetStatus()">
                <div class="fist-sec-content-img" *ngIf="(_homeservice.activeBudgetSec==='first-step')">
                    <div class="fist-sec-budget-img">
                        <img ngOptimizedImage width="239" height="331"
                            ngSrc="assets/images/home/thoughtful-looking-thinking.webp" alt="budget thinking"
                            loading="lazy">
                        <div class="think-animation-box">
                            <div class="hearts_wrapper">
                                <a title="Budget" class="heart green">
                                    <div>Budget?</div>
                                </a>
                                <a title="Brands" class="heart pink">
                                    <div>Brand?</div>
                                </a>
                                <a title="Products" class="heart blue">
                                    <div>Product?</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="first-act-card" *ngIf="_homeservice.activeBudgetSec==='first-step'">
                    <button (click)="onLetsStart()" title="Let's start">Let's start</button>
                </div>
                <div class="budget-card-action budget-card-action-popup"
                    *ngIf="_homeservice.activeBudgetSec!=='first-step'">
                    <div class="budget-card-loader" *ngIf="is_budget_cal_loader">
                        <div class="loder-box">
                            <div class="clock-loader"></div>
                            <div class="loader-text">
                                <span>Creating your house, please wait ...</span>
                            </div>
                        </div>
                    </div>
                    <h4>Smart renovation budget tool</h4>
                    <ul class="steper">
                        <li [ngClass]="{'active-li':getStep() >=1}">1</li>
                        <li [ngClass]="{'active-li':getStep() >=2}">2</li>
                        <li [ngClass]="{'active-li':getStep() >=3}">3</li>
                        <li [ngClass]="{'active-li':getStep() >=4}">4</li>
                    </ul>
                    <div class="budget-card-header-strip">
                        <span class="title one-step-house-typ" *ngIf="_homeservice.activeBudgetSec==='slHType'">Please
                            select your house type</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slSpace'">Please select your house
                            bedrooms
                            type</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slArea'">What is the carpet area
                            of
                            your
                            house?</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slCity'">In which city is your
                            house
                            located?</span>
                    </div>

                    <ul class="budget-card-action-ht-ul" *ngIf="_homeservice.activeBudgetSec==='slHType'">
                        <li>
                            <button class="budget-ht-crad" (click)="_homeservice.onHouseType('Independent House')"
                                [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='Independent House'}"
                                title="Independent House">
                                <div class="budget-ht-crad-img">
                                    <img ngOptimizedImage width="52" height="52"
                                        ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708746/icon-1_heastp.png"
                                        alt="Independent House" loading="lazy">

                                </div>
                                <span>Independent House</span>
                            </button>
                        </li>
                        <li>
                            <button class="budget-ht-crad" (click)="_homeservice.onHouseType('apertment')"
                                [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='apertment'}"
                                title="Apartments">
                                <div class="budget-ht-crad-img">
                                    <img ngOptimizedImage width="52" height="52"
                                        ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708701/icon-2_i46qoc.png"
                                        alt="Apartments" loading="lazy">
                                </div>
                                <span>Apartments</span>
                            </button>
                        </li>
                    </ul>
                    <ul class="budget-card-action-space-ul" *ngIf="_homeservice.activeBudgetSec==='slSpace'">
                        <ng-container *ngFor="let ht of hometypes;">
                            <li *ngIf="hometypes?.length">
                                <button class="spaces-ul-card" (click)="valueChange(ht)"
                                    [ngClass]="{'active-spaces-ul-card':ht.id===_homeservice.htype?.id}"
                                    [title]="ht?.name">
                                    <img ngOptimizedImage width="32" height="32" class="wt-block" [ngSrc]="ht?.icon"
                                        [alt]="ht?.name" loading="lazy">

                                    <span>{{ht?.name}}</span>
                                </button>
                            </li>
                        </ng-container>
                        <!---------loader starts--------------->
                        <ng-container *ngFor="let ht of [1,2,3,4,5,6,7];">
                            <li class="is-loading" style="height:50px" *ngIf="!hometypes?.length">
                                <div class="spaces-ul-card"> </div>
                            </li>
                        </ng-container>
                        <!---------loader ends--------------->
                    </ul>
                    <form   [formGroup]="infoForm" *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'">
                        <div class="form-group">
                            <div class="area-img" *ngIf="_homeservice.activeBudgetSec==='slArea'">
                                <img ngOptimizedImage width="40" height="40"
                                    ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1690549438/icons/area_dmewig.png"
                                    alt="area" loading="lazy">
                            </div>
                            <div class="input-group mb-2 col-md-6 col-sm-12 p-0">
                                <p-inputNumber [style]="{width:'100%',}" formControlName="area" inputId="locale-indian"
                                    mode="decimal" locale="en-IN" placeholder="Enter carpet area" prefix="sqft ">
                                </p-inputNumber>

                                <div class="error-carpet" *ngIf="(submitted && info['area']?.errors)">
                                    <div class="error_arrow_box">
                                        <div class="erro-1" *ngIf="submitted && info['area']?.errors?.['required'] ">
                                            Carpet area required
                                        </div>
                                        <div class="erro-2" *ngIf="submitted && info['area']?.errors?.['min']">Minimum
                                            carpet area
                                            {{minval}} sqft required
                                        </div>
                                        <div class="erro-2" *ngIf="submitted && info['area']?.errors?.['max']">Maximum
                                            carpet area
                                            {{maxval}} sqft</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <ul class="budget-card-action-sl-ul" *ngIf="_homeservice.activeBudgetSec==='slCity'">
                        <ng-container *ngFor="let city of citys;let index=index">
                            <li *ngIf="citys?.length">
                                <button class="budget-sl-crad" (click)="onSelectBudgetCity(index)" [title]="city?.name">
                                    <img ngOptimizedImage width="38" height="38" class="wt-block" [ngSrc]="city?.icon"
                                        [alt]="city?.name" loading="lazy">
                                    <img ngOptimizedImage class="m-block" width="38" height="38"
                                        [ngSrc]="city?.icon_mobile" [alt]="city?.name" loading="lazy">
                                    <span>{{city?.name}}</span>
                                </button>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let city of [1,2,3,4,5]">
                            <li class="is-loading" *ngIf="!citys?.length">
                                <div class="budget-sl-crad"></div>
                            </li>
                        </ng-container>
                    </ul>
                    <!-- <span class="power-head" style="color: #222 !important;margin-left: 18px;">Powered by
                        Afterbrikcks-AI </span> -->
                    <div class="budget-footer budget-footer-mob"
                        *ngIf="( _homeservice.activeBudgetSec !== 'slHType') || (pageLoad && _homeservice.activeBudgetSec==='slArea')">
                        <button class="bug-back bug-back-hm" *ngIf="_homeservice.activeBudgetSec !== 'slHType'"
                            (click)="_homeservice.onBack()"><i class="fa-solid fa-angle-left"></i> Back
                        </button>
                        <button *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'" (click)="onSubmitinfo()">Next
                            <i class="fa-solid fa-angle-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="budget-section-card budget-section-card-url"
                *ngIf="_as?.user_info?.projectInfo || getBudgetStatus()">
                <div class="budget-card-description">
                    <div>
                        <span style="font-size: 24px !important;">Know how much to spend on each room</span>
                        <p class="w-block">Easy-peasy instant spend and budget estimate calculator <br> for every
                            room
                            of your
                            house
                        </p>
                    </div>
                </div>
                <div class="budget-card-action budget-card-action-url">
                    <span class="title" style="text-align: center;">{{budgetTitle}}</span>
                    <ul class="budget-card-action-ht-ul see-budget-ml-o"
                        style="    grid-template-columns: repeat(1, 1fr);width: 100%;">
                        <li>
                            <div class="budget-ht-crad" (click)="budgetContinue()">
                                <img ngOptimizedImage class="wt-block" width="52" height="52"
                                    ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708746/icon-1_heastp.png"
                                    alt="Independent House" loading="lazy">
                                <img ngOptimizedImage class="m-block" width="52" height="52"
                                    ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1685706500/home_64_px_cdj5cs.png"
                                    alt="Independent House" loading="lazy">
                                <span style="margin-top: 4px;" class="budget-ht-crad-text">Check budget</span>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </p-dialog>
</div>


<!---------web Budget Popup End -------->
<!--------- Mobile Budget Popup -------->
<div class="bud-pop-mob" *ngIf="isOnMobilePlatform && isBrowser">
    <p-sidebar [(visible)]="_as.isDisplayBudget" position="bottom" [baseZIndex]="10000" [dismissible]="false"
        [blockScroll]="true">
        <div class="close-popup" (click)="closeBudgetPopup()" style="    right: 16px !important;
        top: 16px !important;">
            <img ngOptimizedImage
                ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1672648092/unnamed_pnyzfp.png" alt="budget"
                loading="lazy" width="20" height="20">
        </div>

        <div class="budget-popup-box ">
            <span class="sec-head m-block" *ngIf="_homeservice.activeBudgetSec==='first-step'">Spend as per your
                budget
            </span>
            <p class="sub-sec-heading m-block" *ngIf="_homeservice.activeBudgetSec==='first-step'">Let us help you to
                renovate within your pocket</p>
            <div class="budget-section-card budget-section-card-url flex-wrap-display bsc-url"
                *ngIf="!_as?.user_info?.projectInfo && !getBudgetStatus()">
                <div class="fist-sec-content-img"
                    *ngIf="(_homeservice.activeBudgetSec==='first-step') || !_as.isOnMobilePlatform">
                    <div class="budget-card-description  w-block">
                        <div>
                            <span>Spend as per your budget</span>
                            <p class="w-block">Let us help you to renovate within your pocket
                            </p>
                        </div>
                    </div>
                    <div class="fist-sec-budget-img">
                        <img ngOptimizedImage width="153" height="211"
                            ngSrc="assets/images/home/thoughtful-looking-thinking.webp" alt="budget thinking"
                            loading="lazy">
                        <div class="think-animation-box">
                            <div class="hearts_wrapper">
                                <a title="Budget" class="heart green">
                                    <div>Budget?</div>
                                </a>
                                <a title="Brands" class="heart pink">
                                    <div>Brand?</div>
                                </a>
                                <a title="Products" class="heart blue">
                                    <div>Product?</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="first-act-card " *ngIf="_homeservice.activeBudgetSec==='first-step'">
                    <button (click)="onLetsStart()" title="Let's start">Let's start</button>
                </div>
                <div class="budget-card-action  budget-card-action-popup"
                    *ngIf="_homeservice.activeBudgetSec!=='first-step'">
                    <h4>Smart renovation budget tool</h4>
                    <div class="budget-card-loader" *ngIf="is_budget_cal_loader">
                        <div class="loder-box">
                            <div class="clock-loader"></div>
                            <div class="loader-text">
                                <span>Creating your house spaces, please wait ...</span>
                            </div>
                        </div>
                    </div>
                    <ul class="steper">
                        <li [ngClass]="{'active-li':getStep() >=1}">1</li>
                        <li [ngClass]="{'active-li':getStep() >=2}">2</li>
                        <li [ngClass]="{'active-li':getStep() >=3}">3</li>
                        <li [ngClass]="{'active-li':getStep() >=4}">4</li>
                    </ul>
                    <div class="budget-card-header-strip">
                        <span class="title one-step-house-typ p-0"
                            *ngIf="_homeservice.activeBudgetSec==='slHType'">Please select your house type</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slSpace'">Please select your house
                            bedrooms
                            type</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slArea'">What is the carpet area
                            of
                            your
                            house?</span>
                        <span class="title" *ngIf="_homeservice.activeBudgetSec==='slCity'">In which city is your
                            house
                            located?</span>
                    </div>
                    <div  >
                        <ul class="budget-card-action-ht-ul bca-ht-ul" *ngIf="_homeservice.activeBudgetSec==='slHType'">
                            <li>
                                <button class="budget-ht-crad" (click)="_homeservice.onHouseType('independenthouse')"
                                    [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='independenthouse'}">
                                    <div class="budget-ht-crad-img">
                                        <img ngOptimizedImage width="62" height="62"
                                            ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708746/icon-1_heastp.png"
                                            alt="Independent House" loading="lazy">

                                    </div>
                                    <span>House</span>
                                </button>
                            </li>
                            <li>
                                <button class="budget-ht-crad" (click)="_homeservice.onHouseType('apertment')"
                                    [ngClass]="{'active-budget-ht-crad':_homeservice.htype==='apertment'}">
                                    <div class="budget-ht-crad-img">
                                        <img ngOptimizedImage width="62" height="62"
                                            ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708701/icon-2_i46qoc.png"
                                            alt="Apartments" loading="lazy">

                                    </div>
                                    <span>Apartments</span>
                                </button>
                            </li>
                        </ul>
                        <ul class="budget-card-action-space-ul" *ngIf="_homeservice.activeBudgetSec==='slSpace'">
                            <ng-container *ngFor="let ht of hometypes;">
                                <li *ngIf="hometypes?.length">
                                    <button class="spaces-ul-card space-ul-card-url" (click)="valueChange(ht)"
                                        [ngClass]="{'active-spaces-ul-card':ht.id===_homeservice.htype?.id}">
                                        <img ngOptimizedImage width="24" height="24" [ngSrc]="ht?.icon" [alt]="ht?.name"
                                            loading="lazy">
                                        <span>{{ht?.name}}</span>
                                    </button>
                                </li>
                            </ng-container>
                            <!---------loader starts--------------->
                            <ng-container *ngFor="let ht of [1,2,3,4,5,6,7];">
                                <li class="is-loading" style="height:50px" *ngIf="!hometypes?.length">
                                    <div class="spaces-ul-card"> </div>
                                </li>
                            </ng-container>
                            <!---------loader ends--------------->
                        </ul>

                        <form   [formGroup]="infoForm" *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'">
                            <div class="form-group">
                                <div class="area-img" *ngIf="_homeservice.activeBudgetSec==='slArea'">
                                    <img ngOptimizedImage width="40" height="40"
                                        ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1690549438/icons/area_dmewig.png"
                                        alt="area" loading="lazy">
                                </div>
                                <div class="input-group mb-2 col-md-6 col-sm-12 p-0">
                                    <p-inputNumber [style]="{width:'100%',}" formControlName="area"
                                        inputId="locale-indian" mode="decimal" locale="en-IN"
                                        placeholder="Enter carpet area" prefix="sqft "> </p-inputNumber>
                                    <div class="error-carpet" *ngIf="(submitted && info['area']?.errors)">
                                        <div class="error_arrow_box">
                                            <div class="erro-1" *ngIf="submitted && info['area']?.errors?.['required'] ">
                                                Carpet area required
                                            </div>
                                            <div class="erro-2" *ngIf="submitted && info['area']?.errors?.['min']">
                                                Minimum
                                                carpet area
                                                {{minval}} sqft required
                                            </div>
                                            <div class="erro-2" *ngIf="submitted && info['area']?.errors?.['max']">
                                                Maximum
                                                carpet area
                                                {{maxval}} sqft</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <ul class="budget-card-action-sl-ul" *ngIf="_homeservice.activeBudgetSec==='slCity'">
                            <ng-container *ngFor="let city of citys;let index=index">
                                <li *ngIf="citys?.length">
                                    <button class="budget-sl-crad" (click)="onSelectBudgetCity(index)"
                                        [title]="city?.name">
                                        <img ngOptimizedImage width="32" height="32" [ngSrc]="city?.icon"
                                            [alt]="city?.name" loading="lazy">
                                        <span>{{city?.name}}</span>
                                    </button>
                                </li>
                            </ng-container>
                            <ng-container *ngFor="let city of [1,2,3,4,5]">
                                <li class="is-loading" *ngIf="!citys?.length">
                                    <div class="budget-sl-crad"></div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <!-- <span class="power-head" style="color: #222 !important;margin-left: 18px;z-index: 9;">Powered by
                        Afterbrikcks</span> -->
                    <div class="budget-footer budget-footer-mob"
                        *ngIf="( _homeservice.activeBudgetSec !== 'slHType') || (pageLoad && _homeservice.activeBudgetSec==='slArea')">
                        <button class="bug-back bug-back-hm" *ngIf="_homeservice.activeBudgetSec !== 'slHType'"
                            (click)="_homeservice.onBack()"><i class="fa-solid fa-angle-left"></i> Back
                        </button>
                        <button title="Next" *ngIf="pageLoad && _homeservice.activeBudgetSec==='slArea'"
                            (click)="onSubmitinfo()">Next <i class="fa-solid fa-angle-right"></i></button>
                    </div>
                </div>

            </div>
            <div class="budget-section-card budget-section-card-url bsc-url"
                *ngIf="_as?.user_info?.projectInfo || getBudgetStatus()">
                <div class="budget-card-description budget-card-description-popup">
                    <div>
                        <span>Know how much to spend on each room</span>
                    </div>
                </div>
                <div class="budget-card-action budget-card-action-url">
                    <span class="title" style="text-align: center;">{{budgetTitle}}</span>
                    <ul class="budget-card-action-ht-ul see-budget-ml-o bca-ht-ul"
                        style="grid-template-columns: repeat(1, 1fr);">
                        <li>
                            <button class="budget-ht-crad budget-ht-crad-mob" (click)="budgetContinue()" title="Check budget">

                                <img ngOptimizedImage class="m-block" width="64" height="64"
                                    ngSrc="https://res.cloudinary.com/afterbricks/image/upload/v1688708746/icon-1_heastp.png"
                                    alt="Independent House" loading="lazy">
                                <span style="margin-top: 4px;">Check budget</span>
                            </button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </p-sidebar>
</div>
<!--------- Mobile Budget Popup End -------->


<div class="ab-arrow-container mt-4 bncss" (click)="mbscrollup()" [hidden]="!is_pageup_button">
    <div class="ab-arrow-up" [hidden]="!is_pageup_button">
      <p class="up" id="page-up1"><i class="fa fa-arrow-up fonticss" aria-hidden="true"></i> </p>
      <p class="aup" id="page-up2"><i class="fa fa-arrow-up fonticss" aria-hidden="true"></i> </p>
    </div>
  </div>

  <app-speed-dial></app-speed-dial>